import {Injectable} from '@angular/core';
import {Capacitor} from "@capacitor/core";

export type UploadExecutionMode = 'native-background' | 'web-direct';

@Injectable({
  providedIn: 'root'
})
export class UploadPlatformStrategyService {
  public getMode(): UploadExecutionMode {
    if (Capacitor.isNativePlatform() && Capacitor.isPluginAvailable('BackgroundRunner')) {
      return 'native-background';
    }

    return 'web-direct';
  }

  public isNativeBackgroundMode(): boolean {
    return this.getMode() === 'native-background';
  }
}
